import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';
import { shortMonthToFull, handleUserLevelAccessPermissions, getAllYears, validateRolesKanpur, validateMonthYears } from '../../../../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import WholeSaleKanpurDistrictData from '../../../../Components/WholeSaleKanpurDistrictData';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import messages from '../.././../../assets/Messages.json';
import othersData from '../../../../others.json';
import zIndex from '@mui/material/styles/zIndex';


const WholeSaleKanpurDistrict = () => {
  const [districtList, setDistrictList] = useState([]);
  const [years, setYears] = useState([]);
  const [months, setMonth] = useState([]);
  const [districtCode, setDistrictCode] = useState('');
  const [yearName, setYearName] = useState('');
  const [monthName, setMonthName] = useState('');
  // const [startDate, setStartDate] = useState('');
  const [dateName, setDateName] = useState('');

  const [startDate, setStartDate] = useState();
  const [WholeSaleKanpurItems, setWholeSaleKanpurItems] = useState([]);
  const [payload, setPayload] = useState([]);
  const [isDivision, setIsDivision] = useState(false);
  const [buttonAccess, setButtonAccess] = useState({ userLevel: '', roles: '', isVisible: false });
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();



  useEffect(() => {

    const currentYear = new Date().getFullYear();

    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)

    // get District By Division ID
    const getDistrictListByDivision = async () => {
      try {
        const response = await axios.post(
          `${API_URL}api/geDistrictListByDivisionId`,
          { division_Id: decode_token.id.USER_LEVEL_LOCATION }, config);
        const allDistrict = response.data;

        if (allDistrict.status) {
          setDistrictList(allDistrict.data);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    }



    // All district list
    const getDistrictList = async () => {

      try {
        const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
        const allDistrict = response.data;
        if (allDistrict.status) {
          let district = allDistrict.data.filter(dist => dist.DISTRICT_CODE === '34')
          setDistrictList(district);
          showLoading(false);
        }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };

    //Get all Months data    
    const getMonthsList = (e) => {
      showLoading(true)
      axios
        .get(`${API_URL}api/graph/getMonths/2019`, config)
        .then((res) => {
          let monthDataResponse = res.data;
          if (monthDataResponse.status) {
            setMonth(monthDataResponse.data);
            showLoading(false)
          }
        })
        .catch((err) => {
          console.error(err);
          showLoading(false);
        });
    }

    const getYearList = () => {
      const startYear = 2011; // Starting year
      const endYear = new Date().getFullYear(); // Ending year

      const yearsArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearsArray.push(year);
      }

      setYears(yearsArray);
      setYearName(endYear); // Set yearName after years are set
    };

    const pageLoadWholeSaleKanpurItems = () => {
      showLoading(true);
      axios
        .get(`${API_URL}/api/otherPrices/getWholeSaleKanpur`, config)
        .then((res) => {

          const { data, status } = res.data;
          if (status) {
            setWholeSaleKanpurItems(data.GroupCodes);
            setTimeout(() => (showLoading(false)), 3000)
          }
        }).catch((err) => {
          console.log(err)
          showLoading(false);
        });
    }

    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateRolesKanpur(decode_token)
        if (role) {

          pageLoadWholeSaleKanpurItems();
          getYearList();
          getMonthsList();

          if (level.userLevel === 'DIVISION LEVEL' && level.roles.includes('DIVADM')) {
            getDistrictListByDivision()
            setIsDivision(true)
          } else {
            getDistrictList()
          }

        } else {

          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false)
      }
    }
    userRole();


  }, []);


  const handleDropdownChange = async (e) => {

    let distCode = ''
    if (e.target.name === "district_name") {
      distCode = e.target.value
    } else {
      distCode = districtCode
    }

    let postData = {
      "districtCode": distCode,
      "monthName": (monthName <= 9) ? `0${monthName}` : monthName,
      "yearName": yearName,
      "dateName": startDate


    };
    switch (e.target.name) {
      case 'district_name':
        setDistrictCode(e.target.value);
        postData.districtCode = e.target.value;
        break;
      case 'month_name':
        setMonthName(e.target.value);
        setStartDate(startDate);
        postData.monthName = (e.target.value <= 9) ? `0${e.target.value}` : e.target.value
        break;
      case 'year_name':
        setYearName(e.target.value);
        postData.yearName = e.target.value
        break;
      default:
        console.log("switch case does not match");
        break;
    }

    if (e.target.name === 'startDate') {
      setStartDate(e.target.value);
      setDateName(e.target.value);
    }
    // Check if all necessary fields are selected
    if (distCode && monthName !== '' && yearName !== '') {
      // postData.monthName(e.target.value<=9)? `0${e.target.value}`:e.target.value;
      showLoading(true);

      try {
        // Make API call to fetch data
        const response = await axios.post(`${API_URL}api/otherPrices/getWholeSaleKanpurwithdata`, postData, config);

        if (response.data.status) {
          setWholeSaleKanpurItems(response.data.data.GroupCodes);
          setPayload(response.data.data.payload);
          showLoading(false);
        }
      } catch (error) {
        console.error('Error posting data:', error);
      } finally {
        showLoading(false);
      }
    }
  };
  const resetMothAndYearField = () => {
    setMonthName('')
    setYearName('')
    setDistrictCode('')
    setStartDate('')
  }


  const handleDateChange = async (date) => {
    if (date) {
      const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
      const currentDate = new Date();

      if (utcDate > currentDate) {
        toast.error("Please select a valid date.", messages.COLOR_RED);
        return;
      }

      if (districtCode === '') {
        toast.error("Please Select District", messages.COLOR_RED);
      }

      // Format the date to YYYY-MM-DD
      const formattedDate = utcDate.toISOString().split('T')[0];

      setStartDate(utcDate);
      setYearName(utcDate.getFullYear());
      setMonthName(utcDate.getMonth() + 1);
      setDateName(formattedDate); // Set dateName with the formatted date

      if (districtCode && monthName !== '' && yearName !== '') {
        let postData = {
          "districtCode": districtCode,
          "monthName": (utcDate.getMonth() + 1 <= 9) ? `0${utcDate.getMonth() + 1}` : utcDate.getMonth() + 1,
          "yearName": utcDate.getFullYear(),
          "dateName": formattedDate // Use formatted date
        };

        try {
          showLoading(true);
          // Make API call to fetch data
          const response = await axios.post(`${API_URL}api/otherPrices/getWholeSaleKanpurwithdata`, postData, config);
          if (response.data.status) {
            setWholeSaleKanpurItems(response.data.data.GroupCodes);
            setPayload(response.data.data.payload);
          }
        } catch (error) {
          console.error('Error posting data:', error);
        } finally {
          showLoading(false);
        }
      }
    }
  };


  const storedLanguage = localStorage.getItem('language');
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  return (
    <>

      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card_white mx-3 mb-3">
            <div className="row align-items-center">
              <div className="col-12">
                <h4 className="page_heading">
                  {/* <span className="text_orange">Price Statistics Uttar Pradesh</span>
                {storedLanguage === 'hi' ? titlesData.hi.IIPMiningReport : titlesData.en.IIPMiningReport} */}

                  <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? othersData.hi.WHOLESALE_KANPUR_DISTRICT_TITLE : othersData.en.WHOLESALE_KANPUR_DISTRICT_TITLE }} />

                </h4>
              </div>
            </div>
            <div className="row align-items-center">
              {isDivision &&
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION} </label>
                  <input typr="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                </div>
              }

              <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-3">
                <label className="w-100">{storedLanguage === 'hi' ? othersData.hi.SELECT_DATE : othersData.en.SELECT_DATE}</label>
                <DatePicker
                  className="form-control calendar_icon"
                  dateFormat="yyyy-MM-dd"
                  placeholderText="YY-MM-DD"
                  selected={startDate}
                  onChange={handleDateChange}
                  popperPlacement="top-start" // 👈 This makes the calendar open above the input

                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => (
                    <div
                      style={{
                        margin: 10,
                        zIndex: "999999",
                        justifyContent: "center",
                      }}
                    >
                      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                        {"<"}
                      </button>
                      <select
                        onChange={(e) => {
                          setYearName(parseInt(e.target.value));
                          changeYear(parseInt(e.target.value));
                        }}
                        value={yearName}
                      >
                        <option value="" disabled>Select Year</option>
                        {years &&
                          years.map((ele, index) => (
                            <option key={index} value={ele}>
                              {ele}
                            </option>
                          ))}
                      </select>

                      <select
                        value={date.getMonth()}
                        onChange={(e) => {
                          setMonthName(e.target.value);
                          changeMonth(e.target.value);
                        }}
                      >
                        <option value="" disabled>Select Month</option>
                        {months &&
                          months
                            .filter((_, i) => !(new Date().getFullYear() === yearName && i > currentMonth))
                            .map((ele, i) => (
                              <option key={i} value={i}>
                                {shortMonthToFull(ele.MONTH)}
                              </option>
                            ))}
                      </select>

                      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                        {">"}
                      </button>
                    </div>
                  )}
                />

              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.DISTRICT : titlesData.en.DISTRICT}</label>
                <select
                  name="district_name"
                  id="district_name"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={districtCode}
                >
                  <option value="" disabled>Select District</option>
                  {districtList &&
                    districtList
                      .slice()
                      .sort((a, b) => a.DISTRICT_NAME.localeCompare(b.DISTRICT_NAME))
                      .map((ele, index) => (
                        <option key={index} value={ele.DISTRICT_CODE}>
                          {ele.DISTRICT_NAME}
                        </option>
                      ))}
                </select>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.MONTH : titlesData.en.MONTH}</label>
                <div className="d-flex align-items-center">
                  <select
                    name="month_name"
                    id="month_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={monthName}
                  >
                    <option value="" disabled>Select Month</option>
                    {months &&
                      months.map((ele, i) => (
                        <option key={i + 1} value={i + 1}>
                          {shortMonthToFull(ele.MONTH)}
                        </option>
                      ))}
                  </select>

                </div>
              </div>



              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? titlesData.hi.CURRENT_YEAR : titlesData.en.CURRENT_YEAR}</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={yearName}
                />
              </div>

            </div>
          </div>

          <div className="card mx-3 mb-3 date_picket_z_index">
            {
              WholeSaleKanpurItems.length > 0 &&
              <WholeSaleKanpurDistrictData
                payload={payload}
                type="wholesaleKanpur"
                config={config}
                resetMothAndYearField={resetMothAndYearField}
                userInfoObject={buttonAccess}
                // sectorCode={sectorCode} 
                yearName={yearName}
                monthName={monthName}
                WholeSaleKanpurItems={WholeSaleKanpurItems}
                districtCode={districtCode}
                dateName={dateName}
                storedLanguage={storedLanguage}
                othersData={othersData}
                titlesData={titlesData}

              />
            }
          </div>
        </div >

      </>
      )
}

      export default WholeSaleKanpurDistrict